/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid } from "@chakra-ui/react";

import IGPTable from "views/admin/proteinDetail/components/IGPTable"
import { columnsDataIGP } from "views/admin/proteinDetail/variables/data"
import sampleIGPData from "views/admin/proteinDetail/variables/sampleIGPData.json"
import React,{ useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function Settings() {
    const { id } = useParams(); // useParams will give us access to all URL parameters
    const [tableData, setTableData] = useState([]); // state for storing the fetched data
    const [loading, setLoading] = useState(true); // state for loading indicator
    const [error, setError] = useState(null); // state for errors

    console.log(id)
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await axios.get(`https://glycopeptideatlasapi.biomarkercenter.org/api/get-protein-igp-data/?protein=${id}`);
                setTableData(response.data.data); // assuming the data is in the 'data' property of the response
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]); // re-fetch data when 'id' changes

    // console.log(tableData)
    // console.log(Array.isArray(tableData.data))
    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }


    // Chakra Color Mode
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <h3>Details for Protein ID: {id}</h3>
            <SimpleGrid
                mb='20px'
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: "20px", xl: "20px" }}>
                
                {/* <SpectraTable/> */}

                <IGPTable
                    columnsData={columnsDataIGP}
                    tableData={tableData} />

            </SimpleGrid>
        </Box>
    );
}
